import VerificationForm from '../Components/Forms/VerificationForm'
import React from 'react'

export const Verification = () => {
  return (
    <VerificationForm/>
  )
}
